module.exports = __webpack_public_path__ + "img/cpzz5@2x.019f0abd.png";